import { defineStore } from 'pinia';
import attachmentApi from '@/api/attachmentApi.js';
import axios from 'axios';


export const useAttachmentStore = defineStore('attachmentStore', {
    state: () => ({
        documentTypes: {}, // кэш типов документов по target
    }),

    actions: {
        async loadDocuments({ target, id, page, search, rows }) {
            try {
                // Поиск пока не реализован на бэкенде для файлов, но параметр оставляем для совместимости
                return await attachmentApi.getDocuments({
                    target,
                    id,
                    page,
                    page_size: rows,
                });
            } catch (error) {
                console.error('Ошибка загрузки документов:', error);
                throw error;
            }
        },
        async loadFiles({ target, id, page, search, rows }) {
            try {
                return await attachmentApi.getFiles({
                    target,
                    id,
                    page,
                    page_size: rows,
                });
            } catch (error) {
                console.error('Ошибка загрузки файлов:', error);
                throw error;
            }
        },
        async fetchDocumentTypes({ target, kind = 'document' }) {
            const cacheKey = `${target}-${kind}`;


            if (this.documentTypes[cacheKey]) {
                return this.documentTypes[cacheKey];
            }

            try {
                const response = await attachmentApi.getDocumentTypes({ target, kind });
                const types = response?.results || [];

                // Фильтруем типы по роли пользователя
                const { useEmployeeStore } = await import('@/stores/employee.js');
                const employeeStore = useEmployeeStore();
                const userPostId = employeeStore.userPostId;


                // Если роль не определена - показываем все (пользователь еще не загружен)
                if (!userPostId) {
                    console.warn('No user post_id - showing all types');
                    this.documentTypes[cacheKey] = types;
                    return types;
                }

                // Фильтруем: показываем только типы, где роль пользователя есть в role_ids
                const filteredTypes = types.filter(type => {
                    // Приводим к числу для корректного сравнения
                    const hasAccess = type.role_ids && type.role_ids.some(roleId =>
                        Number(roleId) === Number(userPostId)
                    );
                    return hasAccess;
                });


                this.documentTypes[cacheKey] = filteredTypes;
                return filteredTypes;
            } catch (error) {
                console.error('Error loading document types:', error);
                this.documentTypes[cacheKey] = [];
                throw error;
            }
        },

        async uploadAttachment({ target, id, file, documentTypeId, fileName, onUploadProgress, kind = 'document' }) {
            if (!file || !target || id == null || !fileName) {
                // Для файлов тип не обязателен
                if (kind === 'document' && documentTypeId == null) {
                    throw new Error('Недостаточно данных для загрузки документа');
                }
            }

            // Шаг 1: Получаем presigned URL
            const presigned = await attachmentApi.getPresignedUrl({
                target,
                id,
                file_name: fileName,
                content_type: file.type,
                document_type_id: documentTypeId,
                kind,
            });


            // Шаг 2: Загружаем файл напрямую в S3
            await axios.put(presigned.url, file, {
                headers: { 'Content-Type': file.type },
                onUploadProgress,
            });

            // Шаг 3: Сообщаем бэкенду, что всё готово
            return await attachmentApi.completeUpload({
                target,
                id,
                key: presigned.key,
                file_name: fileName,
                content_type: file.type,
                size: file.size,
                document_type_id: documentTypeId,
                kind,
            });
        },



        async deleteAttachment(attachmentId) {
            if (!attachmentId) throw new Error('Не указан ID вложения для удаления');
            try {
                await attachmentApi.deleteAttachment(attachmentId);
            } catch (error) {
                console.error('Ошибка удаления вложения:', error);
                throw error;
            }
        },


    },
});